import { createTheme } from '@mui/material/styles';
import { deriveTeamColors } from './utils/colorUtils';

// Default team colors
const DEFAULT_TEAM_COLORS = {
  team1: '#667eea',  // Blue
  team2: '#f5576c',  // Red/Pink
};

/**
 * Carga los colores de las parejas desde localStorage o usa los valores por defecto
 * @returns {object} Objeto con colores derivados para team1 y team2
 */
export const loadTeamColorsFromStorage = () => {
  const team1Color = localStorage.getItem('team1Color') || DEFAULT_TEAM_COLORS.team1;
  const team2Color = localStorage.getItem('team2Color') || DEFAULT_TEAM_COLORS.team2;

  return {
    team1: deriveTeamColors(team1Color),
    team2: deriveTeamColors(team2Color),
  };
};

// Team colors - used consistently across the app
// Exportamos como función para mantener compatibilidad con código existente
// pero permitiendo colores dinámicos
export const TEAM_COLORS = loadTeamColorsFromStorage();

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#dc004e',
      light: '#e33371',
      dark: '#9a0036',
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Segoe UI',
      'Tahoma',
      'Geneva',
      'Verdana',
      'sans-serif',
    ].join(','),
    htmlFontSize: 16, // Base font size
    fontSize: 14, // Default body font size
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '1rem',
          fontWeight: 600,
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
          },
        },
        contained: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(20px)',
          borderRadius: '1rem',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.98)',
          backdropFilter: 'blur(20px)',
          color: '#1a1a1a',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        },
      },
    },
  },
});

export default theme;
